import {connect} from "react-redux";
import React, { Fragment, h} from "preact";
import usePrecontractFctMeta from "../../hooks/usePrecontractFctMeta";
import {Route} from "react-router-dom";
import {ExemptionCATMAD2425} from "./ExemptionCATMAD2425";
import {Redirect} from "react-router";
import {TermsExemption} from "../../../_rx/exemption100-CATMAD-2425/Terms/termsExemption";

function ExemptionRoutes ({ match }) {
    const precontractId = match.params.id;
    const meta = usePrecontractFctMeta(precontractId);

    if (!meta) return <div />
    return <Fragment>
        {
            meta.signed
                ? <Fragment>
                    <Route path={`${match.path}`} component={ExemptionCATMAD2425} exact />
                    <Route path={`${match.path}/normativa`} component={TermsExemption} exact/>
                </Fragment>
                : <Fragment>
                    <Route path={`${match.path}`} exact><Redirect to={`/exemption/${precontractId}/normativa`}/></Route>
                    <Route path={`${match.path}/normativa`} component={TermsExemption} exact/>
                </Fragment>
        }
    </Fragment>
}

ExemptionRoutes = connect(
    ({}) => ({}),
    {})(ExemptionRoutes);
let Exemption = ({match, ...props}) => <ExemptionRoutes match={match} {...props} />
export default Exemption;
